import { observer } from "mobx-react-lite";
import { StoreContext } from "../stores/rootStore";
import { useContext } from "react";
import { DatePickerInput, DateTimePicker } from "@mantine/dates";
import { Group, Stack } from "@mantine/core";

const TimeRangeSelector: React.FC = observer(() => {
  const rs = useContext(StoreContext);
  const ds = rs.dateStore;

  return (
    <Group>
      <DateTimePicker
        value={ds.getDateRange()[0]}
        onChange={(v) => {
          if (v === null) {
            return;
          }
          let upperDate = ds.dateRange[1];
          if (v.getTime() >= upperDate.getTime()) {
            // If after, set 30 minute gap between times
            upperDate = new Date(v.getTime() + 1000 * 60 * 30);
          }
          ds.setDateRange([v, upperDate]);
        }}
        valueFormat="MM/DD/YYYY HH:mm Z"
      />
      -
      <DateTimePicker
        value={ds.getDateRange()[1]}
        onChange={(v) => {
          if (v === null) {
            return;
          }
          let lowerDate = ds.dateRange[0];
          if (v.getTime() <= lowerDate.getTime()) {
            // If after, set 30 minute gap between times
            lowerDate = new Date(v.getTime() - 1000 * 60 * 30);
          }
          ds.setDateRange([lowerDate, v]);
        }}
        valueFormat="MM/DD/YYYY HH:mm Z"
      />
    </Group>
  );
});

export default TimeRangeSelector;
